import React from "react";
import { Switch } from "react-router-dom";
import HomePage from "./home";
import OrderManagement from "./order-management";
import Cost from "./ProjectSetup/Cost";
import Avis from "./avis";
import ErrorOrders from "./error-orders";
import InternalServerError from "./errorPages/InternalServerError";
import AuthenticationError from "./errorPages/authenticationError";
import AllOrders from "./all-orders";
import LoadOrders from "./load-schedule";
import Audit from "./Audit";
import Report from "./Reports";

import ErrorRouteComponent from "./components/errorRoute";
import { SecureRoute } from "@okta/okta-react";
import HomeNavBar from "./home-nav";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { useUserInfo, withUserInfo } from "./common/user-context";
import * as constants from "./constants/constants";
import Forwarder from "./load-build";
import InternalQuoteTabs from "./Internal-Quote";
import ForwarderQuoteTabs from "./ForwarderQuoting";
import { log } from "./Helper";
import ControlTower from "./controlTower";
import Provider from "./ProjectSetup/provider";

const RoutesConfig = (props) => {

  const {userData} = useUserInfo();

  return (
    <div className="w-full">
      <HomeNavBar {...props} />
      {log("Routeconig userdata : ",userData)}
      <Switch>
        <SecureRoute exact path={constants.ROUTE_FOM} component={HomePage} key="home" />

        <SecureRoute
          path={constants.ROUTE_FOM_MANAGE_ORDERS}
          component={OrderManagement}
          key="ManageOrders"
        />

        <SecureRoute
          exact
          path={constants.ROUTE_FOM_RESET_ORDERS}
          component={ErrorOrders}
          key="ManageOrders"
        />
        <SecureRoute
          exact
          from={constants.ROUTE_FOM_MANAGE_QUOTE_ORDERS}
          component={InternalQuoteTabs}
          key="InternalQuoteOrder"
        />

        <SecureRoute
          exact
          path={constants.ROUTE_FOM_MANAGE_QUOTE_SUBMITTED_ORDERS}
          component={InternalQuoteTabs}
          key="InternalSubmittedQuoteOrder"
        />
        <SecureRoute
          exact
          path={constants.ROUTE_FOM_MANAGE_QUOTE_RESULTS}
          component={InternalQuoteTabs}
          key="InternalQuoteResults"
        />

        <SecureRoute
          exact
          path={constants.ROUTE_FOM_PROVIDER}
          component={Provider}
          key="provider"
        />
        <SecureRoute exact path={constants.ROUTE_FOM_COST} component={Cost} />
        <SecureRoute
          exact
          path={constants.ROUTE_FOM_FORWARDER_LOAD_BUILD}
          component={Forwarder}
        />
        <SecureRoute exact path={constants.ROUTE_FOM_FORWARDER_AVIS} component={Avis} />
        <SecureRoute
          exact
          path={constants.ROUTE_FOM_FORWARDER_ALL_ORDERS}
          component={AllOrders}
        />
        <SecureRoute
          exact
          path={constants.ROUTE_FOM_FORWARDER_QUOTE_ORDERS}
          component={ForwarderQuoteTabs}
        />
        <SecureRoute
          exact
          path={constants.ROUTE_FOM_FORWARDER_SUBMITTED_QUOTE_ORDERS}
          component={ForwarderQuoteTabs}
        />
        <SecureRoute
          exact
          path={constants.ROUTE_FOM_FORWARDER_QUOTE_RESULTS_ORDERS}
          component={ForwarderQuoteTabs}
        />
        <SecureRoute
          exact
          path={constants.ROUTE_FOM_ORDER_ADJUSTMENT}
          component={ControlTower}
        />

        <SecureRoute
          exact
          from={constants.ROUTE_FOM_FACTORY_LOAD_SCHEDULE}
          component={LoadOrders}
        />

        <SecureRoute
          exact
          from={constants.ROUTE_FOM_COMPLIANCE_AUDIT}
          component={Audit}
        />

        <SecureRoute
          exact
          from={constants.ROUTE_FOM_REPORTS}
          component={Report}
        />

        <SecureRoute
          exact
          from={constants.ROUTE_AUTH_ERROR}
          component={AuthenticationError}
        />

        <SecureRoute
          exact
          from={constants.ROUTE_FOM_INTERNAL_SERVER_ERROR}
          component={InternalServerError}
        />

        <SecureRoute from="*" component={ErrorRouteComponent} />
      </Switch>
    </div>
  );
};
export default withRouter(withUserInfo(RoutesConfig));
